import { createAction, props } from "@ngrx/store";

export const GET_ALL_MERCHANTS = '[Merchants] Get All Get All Merchants';

export const ERROR = '[Merchants] Error';

export const getAllCustomers = createAction(GET_ALL_MERCHANTS);

export const error = createAction(ERROR, props<{error: string}>());